export const SiteRequestionsCardGridAreaName = 'siteRequestions';
